import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface StyledProps {
  $isFixedHeader?: boolean;
  $noShadow?: boolean;
}

export const Container = styled.div<StyledProps>`
  width: 100%;
  box-shadow: ${({ $noShadow, theme }) => ($noShadow ? 'none' : `0 2px 20px 0 ${theme.appBar.shadow}`)};
  top: 0;
  z-index: 2;
  position: ${({ $isFixedHeader }) => ($isFixedHeader ? 'fixed' : '')};
`;

export const HeaderFixedSpace = styled.div<StyledProps>`
  display: flex;
  min-height: ${({ $isFixedHeader }) => ($isFixedHeader ? '80px' : '')};
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  padding: 0 16px;
  background-color: ${({ theme }) => theme.appBar.background};
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
`;

export const Icon = styled.img`
  flex-shrink: 0;
  cursor: pointer;
`;

export const IconContainer = styled.div`
  min-width: 30px;
`;

export const RightButton = styled.button`
  background: none;
  border: none;

  color: ${ColorPalette.HEX.OriolesOrange};
  font-size: 16px;
  font-weight: 600;
`;
